import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingBarService } from '@ngx-loading-bar/core';

import Swal from 'sweetalert2';

import {
  HeaderService,
  EquipmentsService
} from '../../../shared';

@Component({
  selector: 'app-equipments-edit',
  templateUrl: './equipments-edit.component.html',
  styleUrls: ['./equipments-edit.component.scss']
})
export class EquipmentsEditComponent implements OnInit {
  title = "EDIÇÃO DE EQUIPAMENTO";
  subtitle = "Utilize os campos abaixo para editar o equipamento";
  urlBack = "/panel/equipments/list";

  editEquipment = new FormGroup({
    cdProduto: new FormControl('', Validators.required),
    dsProduto: new FormControl('', Validators.required),
    vlProduto: new FormControl(0),
    cdsProdutoSapAtivo: new FormControl(''),
    cdsProdutoSapDespesa: new FormControl(''),
    cdProdutoMarca: new FormControl('', Validators.required),
    cdProdutoModelo: new FormControl('', Validators.required),
    cdTpProduto: new FormControl(''),
    cdsUnidadeSap: new FormControl('')
  });

  id;

  brandSelected;
  modelSelected;

  constructor(
    private headerService: HeaderService,
    private equipmentsService: EquipmentsService,
    private activatedRoute: ActivatedRoute,
    private loadingBarService: LoadingBarService,
    private router: Router
  ) {
    if (this.activatedRoute.snapshot.params.id) {
      this.id = this.activatedRoute.snapshot.params.id;
    }
  }

  ngOnInit() {
    this.headerService.changeTitle('Edição de equipamento');

    this.headerService.changeSubtitle('');

    this.headerService.changeDatePicker(false);

    this.loadingBarService.start();

    this.equipmentsService.getEquipment(this.id).subscribe((response) => {
      this.editEquipment.patchValue({
        cdProduto: response['data'].cdProduto,
        dsProduto: response['data'].dsProduto,
        vlProduto: response['data'].vlProduto,
        cdsProdutoSapAtivo: response['data'].cdsProdutoSapAtivo,
        cdsProdutoSapDespesa: response['data'].cdsProdutoSapDespesa,
        cdProdutoMarca: response['data'].cdProduto,
        cdProdutoModelo: response['data'].cdProdutoModelo,
        cdTpProduto: response['data'].cdTpProduto,
        cdsUnidadeSap: response['data'].cdsUnidadeSap
      });

      this.brandSelected = `{"id":${response['data'].cdProdutoMarca},"name":"${response['data'].dsProdutoMarca}"}`;
      this.modelSelected = `{"id":${response['data'].cdProdutoModelo},"name":"${response['data'].dsProdutoModelo}"}`;

      this.loadingBarService.complete();
    });
  }

  brand(obj) {
    this.editEquipment.patchValue({
      cdProdutoMarca: obj.id
    });
  }

  model(obj) {
    this.editEquipment.patchValue({
      cdProdutoModelo: obj.id
    });
  }

  updateEquipment() {
    this.loadingBarService.start();

    this.equipmentsService.editEquipment(this.editEquipment.value).subscribe((response) => {
      this.loadingBarService.complete();

      Swal({
        type: "success",
        title: "Equipamento editado",
        text: "O equipamento editado será exibido na listagem",
        confirmButtonText: "Ok, entendi!",
        confirmButtonClass: "sweet-button",
        buttonsStyling: false
      }).then((result) => {
        this.router.navigate([this.urlBack]);
      })
    });
  }

}
